// extracted by mini-css-extract-plugin
var _1 = "Loader-moduleLoader__Q8joA";
export { _1 as "Loader" }
